import { useEffect, useState } from 'react';
import {
  isRealtimeConnected,
  subscribeRealtimeStatus,
  subscribeRealtimeTopic,
  ensureRealtimeConnected,
} from '../utils/realtimeSocket';

export function useRealtimeConnected() {
  const [connected, setConnected] = useState(() => isRealtimeConnected());
  useEffect(() => subscribeRealtimeStatus(setConnected), []);
  return connected;
}

export function useRealtimeTopic(topic, onEvent, enabled = true) {
  const connected = useRealtimeConnected();

  useEffect(() => {
    if (!enabled || !topic) return undefined;
    ensureRealtimeConnected();
    return subscribeRealtimeTopic(topic, onEvent);
  }, [topic, onEvent, enabled]);

  return connected;
}
